import React from 'react'
import { ProjectStatus as ProjectStatusEntries } from '@ztechapps/project.common'
import { StatusColorBadge, StatusColorDot, findStatus } from '@ztechapps/webui.util'

type ProjectStatusProps = { status: string }

export const ProjectStatusBadge = ({ status }: ProjectStatusProps) => (
  <StatusColorBadge status={status} color={findStatus(ProjectStatusEntries, status)} />
)

export const ProjectStatus = ({ status }: ProjectStatusProps) => (
  <StatusColorDot value={status} color={findStatus(ProjectStatusEntries, status)} />
)
